<template>
  <div v-if="initializing" class="app flex-row align-items-center justify-content-center animated fadeIn">
    <font-awesome-icon spin icon="circle-notch" class="text-moremuted display-2"/>
  </div>

  <div v-else class="app">
    <AppHeader fixed>
      <SidebarToggler class="d-lg-none" display="md" mobile />
      <b-link class="navbar-brand" to="#">
        <img class="navbar-brand-full" src="/img/logo-full.png" width="89" height="25" :alt="$t('branding.appName')">
        <img class="navbar-brand-minimized" src="/img/logo-minimized.png" width="30" height="30" :alt="$t('branding.appName')">
      </b-link>
      <SidebarToggler v-if="allowNavigation" class="d-md-down-none" display="lg" />
      <b-navbar-nav :class="{'ml-auto mr-4': $dir.ltr, 'mr-auto ml-4': $dir.rtl}">
        <date :class="{'mr-3': $dir.ltr, 'ml-3': $dir.rtl}"/>
        <Account ref="account"/>
      </b-navbar-nav>
      <!-- <AsideToggler class="d-none d-lg-block" /> -->
      <!--<AsideToggler class="d-lg-none" mobile />-->
    </AppHeader>
    <div class="app-body">
      <AppSidebar v-if="allowNavigation" fixed>
        <SidebarHeader/>
        <SidebarForm/>
        <SidebarNav :navItems="nav"></SidebarNav>
        <SidebarFooter/>
        <SidebarMinimizer/>
      </AppSidebar>
      <main class="main">
        <Breadcrumb v-if="allowNavigation" :list="breadcrumbItems"/>
        
        <div class="container-fluid" :class="{ 'mt-3': !allowNavigation }">
          <system-alerts/>
          
          <router-view></router-view>
        </div>
      </main>
      <!-- <AppAside fixed>
        <DefaultAside/>
      </AppAside> -->
    </div>
    <TheFooter>
      <a target="_blank" :href="$config.websiteUrl">{{$t('branding.appName')}}</a>
      <span class="mx-1">&copy; {{(new Date()).getYear() + 1900 }}</span>
      <change-locale :class="{'ml-auto': $dir.ltr, 'mr-auto': $dir.rtl}"/>
    </TheFooter>
  </div>
</template>

<script>
import nav from '@/_nav'
import Account from './Account'
import Date from './Date'
import SystemAlerts from './SystemAlerts'

import {
  Header as AppHeader,
  SidebarToggler,
  Sidebar as AppSidebar,
  SidebarFooter,
  SidebarForm,
  SidebarHeader,
  SidebarMinimizer, SidebarNav,
  // Aside as AppAside,
  // AsideToggler,
  Footer as TheFooter,
  Breadcrumb,
  ChangeLocale
} from './core'

// import DefaultAside from './DefaultAside'

export default {
  name: 'Full',
  components: {
    Account,
    Date,
    // AsideToggler,
    AppHeader,
    AppSidebar,
    // AppAside,
    TheFooter,
    Breadcrumb,
    ChangeLocale,
    // DefaultAside,
    SidebarFooter,
    SidebarForm,
    SidebarHeader,
    SidebarMinimizer,
    SidebarNav,
    SidebarToggler,
    SystemAlerts
  },
  data () {
    return {
      nav: nav.items
    }
  },
  computed: {
    initializing () {
      return !this.$store.state.$userStatus || !this.$store.state.$settings
    },
    name () {
      return this.$route.name
    },
    breadcrumbItems () {
      return this.$route.matched
    },
    allowNavigation () {
      return this.$store.state.$allowNavigation
    }
  }
}
</script>
